import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import s from './input.module.scss';
export const Input = ({ value, setValue, className, classNameInner, marginBottom, ...rest }) => (_jsx("div", { className: `${s.inner} ${classNameInner}`, style: { marginBottom: marginBottom || '' }, children: _jsx("input", { className: classNames(s.input, className), value: value, onChange: setValue, ...rest }) }));
